/**
 * The UI scale currently applied to the document (PVAL-25852), or 1 when unscaled.
 *
 * **Why callers need it.** Under the scale, pointer events and
 * getBoundingClientRect report viewport pixels, while `style.top`, `offsetWidth`
 * and `document.body.offsetHeight` report the element's own pre-zoom pixels. Any
 * expression combining one of each is wrong by a factor of the scale, so divide
 * viewport-space quantities by this before they meet element-space ones. Every
 * such site is an identity at scale 1.
 *
 * Read from the `--hs-ui-scale` custom property rather than imported from
 * `UserPreferencesService`, which owns it: the consumers are pointer-math sites in
 * `generic-components` and `comments`, both of which `user-preferences` depends on,
 * so importing it back would be a cycle. This lib is a leaf.
 */
export function appliedUiScale(doc: Document = document): number {
  const raw = getComputedStyle(doc.documentElement).getPropertyValue(
    '--hs-ui-scale',
  )
  const scale = Number.parseFloat(raw)

  // Unset, malformed, or zero all mean "no usable scale" — fall back to 1 so
  // callers divide by something safe rather than producing Infinity or NaN.
  return Number.isFinite(scale) && scale > 0 ? scale : 1
}
